export default "__VITE_PUBLIC_ASSET__3b81918f__"